/**
 * Created by Rodrigo Quesada on 21/12/16.
 */
import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {dictionaryValues} from '../../../../common/typescript/objects.util';
import {ValidationError} from '../custom-validator.class';

// region Other Classes
type Errors = {[key: string]: any};

export class ValidationRule {

    readonly id;

    constructor(id: string, readonly regex: RegExp, readonly validationError: ValidationError) {
        this.id = `password-${id}`;
    }

    validate(text: string, errors: Errors) {
        if (!this.regex.test(text)) errors[this.id] = this.validationError;
    }
}
// endregion

// region Utils
function validationRule(id: string, regex: RegExp, errorMessage) {
    return new ValidationRule(id, regex, new ValidationError(errorMessage));
}

function passwordMustContainAtLeast1(text: string) {
    return `Password must contain at least 1 ${text}.`;
}
// endregion

const ValidationRules: {[key: string]: ValidationRule} = {
    LENGHT: validationRule('lenght', /^.{8,100}$/, 'Password length must be 8 characters or longer.'),
    _1_LOWER: validationRule('lowercase', /[a-z]/, passwordMustContainAtLeast1('lowercase letter')),
    _1_UPPER: validationRule('uppercase', /[A-Z]/, passwordMustContainAtLeast1('uppercase letter')),
    _1_DIGIT: validationRule('digit', /\d/, passwordMustContainAtLeast1('digit')),
    _1_SYMBOL: validationRule('symbol', /\W/, passwordMustContainAtLeast1('special character'))
};

let passwordRules = dictionaryValues(ValidationRules);

export function passwordValidator(control: AbstractControl): Errors {
    let text = control.value;
    let errors = {};

    passwordRules.forEach(r => r.validate(text, errors));

    return errors;
}

@Directive({
    selector: '[passwordValidation]',
    providers: [{provide: NG_VALIDATORS, useExisting: PasswordValidatorDirective, multi: true}]
})
export class PasswordValidatorDirective implements Validator {

    private valFn = passwordValidator;

    validate(control: AbstractControl): Errors {
        return this.valFn(control);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/password/password-validator.directive.ts